import React, { useEffect, useState } from "react"
import Header from "../Global/Header"
import PageContent from "../Global/PageContent"
import Grid from "../Global/Grid"
import Popup from "./Popup"
import PopupTelemed from "./PopupTelemed"
import PopupWrapper from "../Global/Popup"
import PopupWhats from "./PopupWhats"
import api from "../../services/api"
import "./style.css"
import axios from "axios"
import updateLead from "../../inc/Fx/updateLead"
import DisclaimerAgendamento from "./DisclaimerAgendamento"
import Footer from "../Global/Footer"
import Alert from "../Global/Alert"

// const CONSULTAS = 0
// const EXAMEIMG = 2
// const COLETADOMICILIAR = 3

export default function Home() {
  const [popup, togglePopup] = useState(false)
  const [popupTelemed, togglePopupTelemed] = useState(false)
  const [popupWhats, toggleWhats] = useState(false)
  const [showExpiredAlert, setShowExpiredAlert] = useState(false)

  // [CONTENÇÃO 2026-07-06] auth desativada — religar no fix-forward.
  // Sem o interceptor, ninguém seta logout_reason; alerta "Sessão expirada" desligado.
  // useEffect(() => {
  //   if (localStorage.getItem("logout_reason") === "expired") {
  //     setShowExpiredAlert(true)
  //     localStorage.removeItem("logout_reason")
  //   }
  // }, [])

  useEffect(() => {
    //captura de parametros da URL
    sessionStorage.clear()
    const queryParams = new URLSearchParams(window.location.search)
    const source = queryParams.get("utm_source")
    const medium = queryParams.get("utm_medium")
    const content = queryParams.get("utm_content")
    const campaign = queryParams.get("utm_campaign")
    const term = queryParams.get("utm_term")

    if (source) sessionStorage.setItem("utm_source", source)
    if (medium) sessionStorage.setItem("utm_medium", medium)
    if (content) sessionStorage.setItem("utm_content", content)
    if (campaign) sessionStorage.setItem("utm_campaign", campaign)
    if (term) sessionStorage.setItem("utm_term", term)
    //retorno de handle de Alertas
    if (localStorage.getItem("showPopupOnReturn") === "true") {
      togglePopup(true)
      localStorage.removeItem("showPopupOnReturn")
    }

    async function initializeLead(tentativas = 3) {
      try {
        const response = await api.post("/lead")
        const { success, content } = response.data
        if (success) {
          sessionStorage.setItem("client", content)
        }
      } catch {
        if (tentativas > 1) {
          setTimeout(() => initializeLead(tentativas - 1), 2000)
        }
      }
    }
    if (!sessionStorage.getItem("client")) {
      initializeLead()
    }
  }, [])

  const handleConsultas = () => {
    updateLead({
      UTM_SOURCE: sessionStorage.getItem("utm_source"),
      UTM_MEDIUM: sessionStorage.getItem("utm_medium"),
      UTM_CONTENT: sessionStorage.getItem("utm_content"),
      UTM_CAMPAIGN: sessionStorage.getItem("utm_campaign"),
      UTM_TERM: sessionStorage.getItem("utm_term"),
    })
    togglePopup(true)
  }
  const handleAreaDoPaciente = () => {
    window.location.replace("https://app.segmedic.com.br/sign-in")
  }
  const handleExamesImg = () => {
    // window.location.replace("https://exames.segmedic.com.br/")
    window.location.replace(
      "https://exames.segmedic.com.br/",
    )
  }

  const handleTelemedicina = () => {
    updateLead({
      UTM_SOURCE: sessionStorage.getItem("utm_source"),
      UTM_MEDIUM: sessionStorage.getItem("utm_medium"),
      UTM_CONTENT: sessionStorage.getItem("utm_content"),
      UTM_CAMPAIGN: sessionStorage.getItem("utm_campaign"),
      UTM_TERM: sessionStorage.getItem("utm_term"),
      FEEGOW_TIPO_AGENDAMENTO: "telemedicina-conexa",
    })
    togglePopupTelemed(true)
  }

  return (
    <main className="site-main-homepage">
      <Header hideFollowUP={true} />
      <PageContent>
        <Popup isOpen={popup} toggle={togglePopup}></Popup>
        <PopupTelemed isOpen={popupTelemed} toggle={togglePopupTelemed} />
        <Alert isOpen={showExpiredAlert} onClose={setShowExpiredAlert} title="Sessão expirada">
          <p>Sua sessão expirou por inatividade. Por favor, faça login novamente para continuar o agendamento.</p>
        </Alert>

        <PopupWrapper ID="popupWhats" open={popupWhats} handle={toggleWhats}>
          <PopupWhats />
        </PopupWrapper>

        <div className="title_home">
          <div>
            <h2>
              Bem-vindo ao <span>Agendamento Online</span>, a plataforma
              <br />
              de Agendamento da Segmedic
            </h2>
            <p>
              Para começar o processo, escolha o <br /> que você deseja agendar
              hoje.
            </p>
          </div>
        </div>
        {/* Versão Desktop - Grid Normal */}
        <form className="grid_home-initial">
          <Grid corDeFundo="#fff">
            <div ID="CONSULTAS" className="item" onClick={handleConsultas}>
              <div className="input-radio">
                <label htmlFor="input-consultas-medicas">
                  <input
                    type="radio"
                    name="select-especialidades"
                    id="input-consultas-medicas"
                    value="consultas-medicas"
                  />
                  <div className="input-label">
                    <div className="icon-initial">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 -960 960 960"
                        width="24"
                      >
                        <path d="M540-80q-108 0-184-76t-76-184v-23q-86-14-143-80.5T80-600v-240h120v-40h80v160h-80v-40h-40v160q0 66 47 113t113 47q66 0 113-47t47-113v-160h-40v40h-80v-160h80v40h120v240q0 90-57 156.5T360-363v23q0 75 52.5 127.5T540-160q75 0 127.5-52.5T720-340v-67q-35-12-57.5-43T640-520q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 70T800-407v67q0 108-76 184T540-80Zm220-400q17 0 28.5-11.5T800-520q0-17-11.5-28.5T760-560q-17 0-28.5 11.5T720-520q0 17 11.5 28.5T760-480Zm0-40Z" />
                      </svg>
                    </div>
                    <p>Agende agora</p>
                    <p>
                      <strong>
                        Consultas <br /> Médicas
                      </strong>
                    </p>
                  </div>
                </label>
              </div>
            </div>
            <div ID="TELEMED" className="item" onClick={handleTelemedicina}>
              <div className="input-radio">
                <label htmlFor="input-telemed-conexa">
                  <input
                    type="radio"
                    name="select-especialidades"
                    id="input-telemed-conexa"
                    value="telemed-conexa"
                    disabled={false}
                    // checked={choice === EXAMEIMG}
                  />
                  <div className="input-label">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 -960 960 960"
                      width="24"
                      fill="#e3e3e3"
                    >
                      <path d="m720-560-58-56 64-64H520v-80h206l-62-62 56-58 160 162-160 158Zm78 440q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67Z" />
                    </svg>
                    <p>Telemedicina</p>
                    <p>
                      <strong>
                        Consulte <br />
                        Online
                      </strong>
                    </p>
                  </div>
                </label>
              </div>
            </div>
            <div ID="EXAMEIMG" className="item" onClick={handleExamesImg}>
              <div className="input-radio">
                <label htmlFor="input-exames-de-imagem">
                  <input
                    type="radio"
                    name="select-especialidades"
                    id="input-exames-de-imagem"
                    value="exames-de-imagem"
                    disabled={false}
                    // checked={choice === EXAMEIMG}
                  />
                  <div className="input-label">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 -960 960 960"
                      width="24"
                    >
                      <path d="M80-600v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v120h-80v-120H160v120H80Zm80 440q-33 0-56.5-23.5T80-240v-120h80v120h640v-120h80v120q0 33-23.5 56.5T800-160H160Zm240-120q11 0 21-5.5t15-16.5l124-248 44 88q5 11 15 16.5t21 5.5h240v-80H665l-69-138q-5-11-15-15.5t-21-4.5q-11 0-21 4.5T524-658L400-410l-44-88q-5-11-15-16.5t-21-5.5H80v80h215l69 138q5 11 15 16.5t21 5.5Zm80-200Z" />
                    </svg>
                    <p>Agende agora</p>
                    <p>
                      <strong>
                        Exames e<br /> Procedimentos
                      </strong>
                    </p>
                  </div>
                </label>
              </div>
            </div>
            <div
              ID="AREADOPACIENTE"
              className="item"
              onClick={handleAreaDoPaciente}
            >
              <div className="input-radio">
                <label htmlFor="input-coleta-domiciliar">
                  <input
                    type="radio"
                    name="select-especialidades"
                    id="input-coleta-domiciliar"
                    value="coleta-domiciliar"
                    disabled={false}
                    // checked={choice === COLETADOMICILIAR}
                  />
                  <div className="input-label">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                    >
                      <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                    </svg>
                    <p>Checar consultas</p>
                    <p>
                      <strong>
                        Área do <br /> Paciente
                      </strong>
                    </p>
                  </div>
                </label>
              </div>
            </div>
          </Grid>
        </form>
        {/* Versão Mobile - Grid 2x2 */}
        <div className="grid_home-mobile">
          <div id="CONSULTAS-MOBILE" className="item" onClick={handleConsultas}>
            <div className="input-radio">
              <label htmlFor="input-consultas-medicas-mobile">
                <input
                  type="radio"
                  name="select-especialidades-mobile"
                  id="input-consultas-medicas-mobile"
                  value="consultas-medicas"
                />
                <div className="input-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path d="M540-80q-108 0-184-76t-76-184v-23q-86-14-143-80.5T80-600v-240h120v-40h80v160h-80v-40h-40v160q0 66 47 113t113 47q66 0 113-47t47-113v-160h-40v40h-80v-160h80v40h120v240q0 90-57 156.5T360-363v23q0 75 52.5 127.5T540-160q75 0 127.5-52.5T720-340v-67q-35-12-57.5-43T640-520q0-50 35-85t85-35q50 0 85 35t35 85q0 39-22.5 70T800-407v67q0 108-76 184T540-80Zm220-400q17 0 28.5-11.5T800-520q0-17-11.5-28.5T760-560q-17 0-28.5 11.5T720-520q0 17 11.5 28.5T760-480Zm0-40Z" />
                  </svg>

                  <p className="title">Consultas</p>

                  {/* <p className="desc">
                    São mais de 30 Especialidades para atender a você.
                  </p> */}

                  <strong>
                    <a className="action-link">Agendar agora </a>
                  </strong>
                </div>
              </label>
            </div>
          </div>

          <div id="TELEMED-MOBILE" className="item" onClick={handleTelemedicina}>
            <div className="input-radio">
              <label htmlFor="input-telemed-conexa-mobile">
                <input
                  type="radio"
                  name="select-especialidades-mobile"
                  id="input-telemed-conexa-mobile"
                  value="telemed-conexa"
                  disabled={false}
                />
                <div className="input-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                    fill="#e3e3e3"
                  >
                    <path d="m720-560-58-56 64-64H520v-80h206l-62-62 56-58 160 162-160 158Zm78 440q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67Z" />
                  </svg>

                  <p className="title">Telemedicina</p>

                  {/* <p>Consulte um médico online de onde estiver</p> */}

                  <strong>
                    <a className="action-link">Consultar agora </a>
                  </strong>
                </div>
              </label>
            </div>
          </div>

          <div ID="EXAMEIMG-MOBILE" className="item" onClick={handleExamesImg}>
            <div className="input-radio">
              <label htmlFor="input-exames-de-imagem-mobile">
                <input
                  type="radio"
                  name="select-especialidades-mobile"
                  id="input-exames-de-imagem-mobile"
                  value="exames-de-imagem"
                  disabled={false}
                />
                <div className="input-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                  >
                    <path d="M80-600v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v120h-80v-120H160v120H80Zm80 440q-33 0-56.5-23.5T80-240v-120h80v120h640v-120h80v120q0 33-23.5 56.5T800-160H160Zm240-120q11 0 21-5.5t15-16.5l124-248 44 88q5 11 15 16.5t21 5.5h240v-80H665l-69-138q-5-11-15-15.5t-21-4.5q-11 0-21 4.5T524-658L400-410l-44-88q-5-11-15-16.5t-21-5.5H80v80h215l69 138q5 11 15 16.5t21 5.5Zm80-200Z" />
                  </svg>

                  <p className="title">Exame</p>

                  {/* <p>Os exames que você precisa bem na palma da sua mão</p> */}

                  <strong>
                    <a className="action-link">Agendar agora </a>
                  </strong>
                </div>
              </label>
            </div>
          </div>

          <div
            ID="AREADOPACIENTE-MOBILE"
            className="item"
            onClick={handleAreaDoPaciente}
          >
            <div className="input-radio">
              <label htmlFor="input-coleta-domiciliar-mobile">
                <input
                  type="radio"
                  name="select-especialidades-mobile"
                  id="input-coleta-domiciliar-mobile"
                  value="coleta-domiciliar"
                  disabled={false}
                />
                <div className="input-label">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24px"
                    viewBox="0 -960 960 960"
                    width="24px"
                  >
                    <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H200Zm0-80h560v-400H200v400Zm0-480h560v-80H200v80Zm0 0v-80 80Zm280 240q-17 0-28.5-11.5T440-440q0-17 11.5-28.5T480-480q17 0 28.5 11.5T520-440q0 17-11.5 28.5T480-400Zm-160 0q-17 0-28.5-11.5T280-440q0-17 11.5-28.5T320-480q17 0 28.5 11.5T360-440q0 17-11.5 28.5T320-400Zm320 0q-17 0-28.5-11.5T600-440q0-17 11.5-28.5T640-480q17 0 28.5 11.5T680-440q0 17-11.5 28.5T640-400ZM480-240q-17 0-28.5-11.5T440-280q0-17 11.5-28.5T480-320q17 0 28.5 11.5T520-280q0 17-11.5 28.5T480-240Zm-160 0q-17 0-28.5-11.5T280-280q0-17 11.5-28.5T320-320q17 0 28.5 11.5T360-280q0 17-11.5 28.5T320-240Zm320 0q-17 0-28.5-11.5T600-280q0-17 11.5-28.5T640-320q17 0 28.5 11.5T680-280q0 17-11.5 28.5T640-240Z" />
                  </svg>

                  <p className="title">Checar Consultas</p>

                  {/* <p>Acesse o seu histórico de Consultas e Exames</p> */}

                  <strong>
                    <a className="action-link">Área do Paciente </a>
                  </strong>
                </div>
              </label>
            </div>
          </div>
        </div>

        <DisclaimerAgendamento />

        <Footer />
      </PageContent>
    </main>
  )
}
